import React from "react";
import DataSummaryTable from "../components/table/DataSummaryTable";
import { useGetTargetMissedQuery } from "../redux/service/modules/dashboard";
import { useLazyGetLazyTargetMissedQuery } from "../redux/service/modules/dashboard/lazzyQuery";

const TargetsMissedTable = ({ initialDateRange, filters }) => {
    const highlightRules = [
        {
          column: "scheduled_missed",
          condition: "greaterThan",
          value: 3,
          backgroundColor: "#fff1f1",
          borderColor: "#FF0000",
        },
        {
          column: "scheduled_missed",
          condition: "between",
          value: [1, 3],
          backgroundColor: "#FFF8E7",
          borderColor: "#FFA500",
        },
      ];
    const [exportToExcelQuery] = useLazyGetLazyTargetMissedQuery()
    return (
        <DataSummaryTable
            title="Targets Missed"
            initialDateRange={initialDateRange}
            queryHook={useGetTargetMissedQuery}
            exportToExcelQuery={exportToExcelQuery}
            maxRows={6}
            filters={filters}
            highlightRules={highlightRules}
            setHeaderHeight={"1.5rem"}
        />
    );
};

export default TargetsMissedTable;
